export const industries = {
  food: {
    bg: '../assets/information/industry/foodandbev-cover.jpg',
    frame_head: {
      header: 'Food and Beverage',
      subheader:
        'From franchises to mom and pop diners, foodservice providers ' +
        'across America choose Bambee to help them navigate the many complex and ' +
        'ever-changing federal and state regulations. We support these businesses ' +
        'with their compliance needs, and help them avoid litigation with our safe ' +
        'termination plans.',
    },
    frame_body: {
      header: 'Common Risks For Food & Beverage Owners',
      subheader: [
        'Employees working past their designated shifts during a rush period without tracking overtime',
        'In-house team performing common fixes like replacing light bulbs and fixing kitchen appliances to save money without professionally training.',
        'Employees forgetting to clock out for breaks.',
        'Incomplete training for new hires brought on to help with busy season',
        'Employees switching shifts without approval and working too many hours throughout the week.',
      ],
    },
    business_lists: [
      'Restaurants',
      'Catering',
      'Quick-Service',
      'Franchises',
      'Coffee Shops',
      'Bars',
      'Cafes',
      'Food Trucks',
      'Fast Food',
    ],
  },
  retail: {
    frame_head: {
      header: 'Retail',
      subheader:
        'Whether you manage a brick and mortar shop or a remote team that supports your online store, Bambee can help you navigate the many complex and ever-changing federal and state labor regulations that dictate how your team works for you. We support businesses of every size and kind with their compliance needs, and help them avoid litigation with our safe termination plans. ',
    },
    frame_body: {
      header: 'Common Compliance Risks For Retail Business Owners',
      subheader: [
        'Lack of sufficient documentation of warnings needed to terminate unsatisfactory employees',
        'Employees working past their designated shifts during a rush period without tracking overtime.',
        'Employees forgetting to clock out for breaks.',
        'Incomplete training for new hires brought on to help with busy season',
        'New hires using their own wages to purchase own uniforms.',
      ],
    },
    business_lists: [
      'Department Stores',
      'Discount Stores',
      'Supermarkets',
      'Warehouses',
      'Liquor Stores',
      'Specialty Shops',
      'Malls',
      'E-tailers',
    ],
  },

  entertainment: {
    frame_head: {
      header: 'Entertainment / Social',
      subheader:
        'With its high competition for talent, management of many different employee types, high turnover, and regular unemployment, the entertainment industry is at high risk of non-compliance with state and federal labor regulations. Bambee can help improve your HR processes to avoid litigation so you can focus on your work. We support businesses of every size and kind with their compliance needs and termination plans.',
    },
    frame_body: {
      header:
        'Common Compliance Risks For Entertainment Industry Business Owners',
      subheader: [
        'Mismanaging of wage process resulting in expensive litigation',
        'Lack of sufficient documentation of warnings needed to terminate unsatisfactory employees',
        'Non-compliance with wage and hour laws, specifically overtime exemption salary',
        'Insufficient training for managers that results in poor team management',
        'Non-compliance with insurance laws, specifically ACA changes',
      ],
    },
    business_lists: [
      'Agencies',
      'Film Studios',
      'Television/Radio',
      'Print Media',
      'Online',
    ],
  },

  healthcare: {
    frame_head: {
      header: 'Healthcare / Medical',
      subheader:
        ' The healthcare industry is governed by many complex regulations that must be followed ' +
        'to the letter to avoid expensive fines and litigation. Bambee can help you navigate the many complex ' +
        'and ever-changing federal and state labor regulations, and create customized HR processes and ' +
        'termination plans that work for you.',
    },
    frame_body: {
      header:
        'Common Compliance Risks For Healthcare / Medical Business Owners',
      subheader: [
        'Employee health issues or injuries as a result of working too many hours',
        'Mismanagement of mandated performance evaluations that result in loss of government funding',
        'Non-compliance with insurance laws',
        'Unsafe working conditions',
        'Improper or incomplete filing of immigration compliance documents',
      ],
    },
    business_lists: [
      'Pharmacies',
      'Dental Clinic',
      'Medical Offices',
      'Urgent Cares',
      'Vision Clinic',
      'Hospitals',
      'Startups',
      'Medical Manufacturing',
      'Holistic Care',
      'Naturopathic Clinics',
    ],
  },

  technology: {
    frame_head: {
      header: 'Technology / Software',
      subheader:
        'Tech companies are fast-paced and focused on growth - but that can often mean HR compliance ' +
        'neglect. Bambee helps navigate the many complex and ever-changing federal and state labor regulations ' +
        'so businesses can get back to work. We support these companies with their compliance needs, and help ' +
        'them avoid litigation with our safe termination plans.',
    },
    frame_body: {
      header:
        'Common Compliance Risks For Technology / Software Business Owners',
      subheader: [
        'Non-compliance with wage & hour laws, specifically overtime exemption salary',
        'Lack of sufficient documentation of warnings needed to terminate unsatisfactory employees',
        'Lack of compliance with anti-discrimination laws',
        'Insufficient training for managers that results in poor team management and high turnover',
        'Non-compliance with insurance and ACA laws as team sizes grow rapidly',
      ],
    },
    business_lists: [
      'IT',
      'Software',
      'Startups',
      'VR',
      'Social Media',
      'Web Development',
      'E-commerce',
    ],
  },

  education: {
    frame_head: {
      header: 'Education',
      subheader:
        'With its limited resources and highly sensitive work, the education sector is especially ' +
        'at risk of non-compliance with state and federal labor regulations. Bambee can help improve your HR ' +
        'processes to avoid litigation and improve retention. We support businesses of every size and kind with ' +
        'their compliance needs and termination plans.',
    },
    frame_body: {
      header: 'Common Compliance Risks For Education Industry Business Owners',
      subheader: [
        'Lack of sufficient documentation of warnings needed to terminate unsatisfactory employees',
        'Mismanagement of HR processes resulting in poor employee retention',
        'Non-compliance with wage and hour laws, specifically overtime exemption salary',
        'Non-compliance with insurance laws, specifically ACA changes',
        'Employee non-compliance with school regulations',
      ],
    },
    business_lists: [
      'Schools',
      'Colleges',
      'Universities',
      'Tutoring Services',
    ],
  },

  hospitality: {
    frame_head: {
      header: 'Hotels / Resorts',
      subheader:
        'Motels, hotels, resorts, spas, and more choose Bambee to help them navigate the many ' +
        'complex and ever-changing federal and state employee & labor regulations. We support these businesses ' +
        'with their compliance needs, and help them avoid litigation with our safe termination plans.',
    },
    frame_body: {
      header: 'Common Compliance Risks For Hotel Industry Business Owners',
      subheader: [
        'Employees working past their designated shifts during a rush period without tracking overtime.',
        'In-house team performing common fixes like replacing light bulbs and fixing kitchen appliances to save money without professionally training.',
        'Employees forgetting to clock out for breaks.',
        'Incomplete training for new hires brought on to help with busy season',
        'Employees switching shifts without approval and working too many hours throughout the week.',
      ],
    },
    business_lists: [
      'Hotels',
      'Motels',
      'Resorts',
      'Spas',
      'Independent',
      'Chain',
    ],
  },

  security: {
    frame_head: {
      header: 'Law Enforcement / Security',
      subheader:
        'Managing a team of security personnel has a unique set of challenges - ' +
        'while they work to protect the public, you work to protect them. Let Bambee protect you. ' +
        'We support businesses of every size and kind with their labor regulation compliance needs, ' +
        'and help them avoid litigation with our safe termination plans.',
    },
    frame_body: {
      header:
        'Common Compliance Risks For Law Enforcement / Security Business Owners',
      subheader: [
        'Team communication issues that can escalate and result in litigation',
        'Mismanagement of worker’s compensation claims',
        'Non-compliance with insurance laws',
        'Lack of safety gear and unsafe working conditions',
        'Improper or incomplete filing of immigration compliance documents ',
      ],
    },
    business_lists: ['Private Security', 'Police', 'Bodyguard'],
  },

  caregiver: {
    frame_head: {
      header: 'Home Health Aide / Caregivers',
      subheader:
        ' The healthcare industry is governed by many complex regulations that must be ' +
        'followed to the letter to avoid expensive fines and litigation. Bambee can help you navigate ' +
        'the many complex and ever-changing federal and state labor regulations, and create customized ' +
        'HR processes and termination plans that work for you.',
    },
    frame_body: {
      header:
        'Common Compliance Risks For Home Health Aide/Caregiver Business Owners',
      subheader: [
        'Employee health issues or injuries as a result of working too many hours',
        'Mismanagement of mandated performance evaluations that result in loss of government funding',
        'Non-compliance with insurance laws',
        'Unsafe working conditions',
        'Improper or incomplete filing of immigration compliance documents',
      ],
    },
    business_lists: ['Senior Caregiver', 'Nannies', 'Live-in Assistants'],
  },

  insurance: {
    frame_head: {
      header: 'Insurance',
      subheader:
        'With its high competition for talent and management of many different employee types, ' +
        'the insurance industry is especially at risk of non-compliance with state and federal labor regulations. ' +
        'Bambee can help improve your HR processes to avoid litigation and improve retention. We support ' +
        'businesses of every size and kind with their compliance needs and termination plans.',
    },
    frame_body: {
      header: 'Common Compliance Risks For Insurance Industry Business Owners',
      subheader: [
        'Mismanagement of HR processes resulting in poor employee retention',
        'Lack of sufficient documentation of warnings needed to terminate unsatisfactory employees',
        'Non-compliance with wage and hour laws, specifically overtime exemption salary',
        'Insufficient training for managers that results in poor team management',
        'Non-compliance with insurance laws, specifically ACA changes',
      ],
    },
    business_lists: [
      'Life Insurance',
      'Auto Insurance',
      'Commercial Insurance',
      'Health Insurance',
    ],
  },

  manufacturing: {
    frame_head: {
      header: 'Manufacturing',
      subheader:
        'Running a manufacturing company comes with many compliance risks, especially ' +
        'while the industry faces hiring challenges that take up so many HR resources. Bambee can ' +
        'help you navigate the many complex and ever-changing federal and state labor regulations ' +
        'to help protect your business, so you can focus on staffing it. We support businesses of ' +
        'every size and kind with their compliance needs, and help them avoid litigation with our ' +
        'safe compliance and termination plans.',
    },
    frame_body: {
      header:
        'Common Compliance Risks For Manufacturing Industry Business Owners',
      subheader: [
        'Team communication issues that can escalate and result in litigation',
        'Mismanagement of worker’s compensation claims',
        'Non-compliance with insurance laws',
        'Lack of safety gear and unsafe working conditions',
        'Improper or incomplete filing of immigration compliance documents',
      ],
    },
    business_lists: [
      'Food Processing',
      'Chemical Production',
      'Automotive',
      'Textiles',
      'Furniture',
      'Office Supplies',
    ],
  },

  customersupport: {
    frame_head: {
      header: 'Call Centers / Customer Support',
      subheader:
        'Whether you manage a team of representatives in house or remotely, Bambee can help you ' +
        'navigate the many complex and ever-changing federal and state labor regulations that dictate how your ' +
        'employees work for you. We support businesses of every size and kind with their compliance needs, and ' +
        'help them avoid litigation with our safe termination plans.',
    },
    frame_body: {
      header: 'Common Compliance Risks For Call Center Business Owners',
      subheader: [
        'Lack of sufficient documentation of warnings needed to terminate unsatisfactory employees',
        'Employees working past their designated shifts during a rush period without tracking overtime.',
        'Employees forgetting to clock out for breaks.',
        'Incomplete training for new hires brought on to help with busy season',
        'New hires using their own wages to purchase own uniforms.',
      ],
    },
    business_lists: ['Telemarketers', 'Call Centers', 'Remote Sales Center'],
  },

  energy: {
    frame_head: {
      header: 'Energy',
      subheader:
        'The energy industry is expanding rapidly and its goods are in high demand, ' +
        'but it faces the difficult challenge of a lack of skilled talent to fill the roles left ' +
        'by retiring baby boomers in its workforce. Bambee can help improve your HR processes to ' +
        'avoid litigation and improve retention. We support businesses of every size and kind with ' +
        'their labor regulation compliance needs, and help them avoid litigation with our safe termination plans.',
    },
    frame_body: {
      header: 'Common Compliance Risks For Energy Industry Business Owners',
      subheader: [
        'Non-compliance with wage and hour laws, specifically overtime exemption salary',
        'Lack of sufficient documentation of warnings needed to terminate unsatisfactory employees',
        'Lack of compliance with anti-discrimination laws',
        'Insufficient training for managers that results in poor team management and high turnover',
        'Non-compliance with insurance and ACA laws as team sizes grow rapidly',
      ],
    },
    business_lists: [
      'Gas',
      'Electrical',
      'Coal',
      'Oil',
      'Nuclear',
      'Renewable',
    ],
  },

  construction: {
    frame_head: {
      header: 'Construction',
      subheader:
        'Managing a construction company comes with a unique set of challenges; high turnover rates, ' +
        'risks of workplace hazards, and complex immigration compliance. Bambee can help you navigate the many ' +
        'complex and ever-changing federal and state labor regulations, and create a customized HR process that ' +
        'works for you. We support businesses of every size and kind with their compliance needs, and help them ' +
        'avoid litigation with our safe termination plans.',
    },
    frame_body: {
      header: 'Common Compliance Risks For Construction Business Owners',
      subheader: [
        'Incomplete safety training',
        'Mismanagement of worker’s compensation claims',
        'Non-compliance with insurance laws',
        'Lack of safety gear and unsafe working conditions',
        'Improper or incomplete filing of immigration compliance documents',
      ],
    },
    business_lists: [
      'Small Renovation',
      'General Contractors',
      'Owner-builder',
      'Real Estate Developer',
    ],
  },

  nonprofit: {
    frame_head: {
      header: 'Non-Profit',
      subheader:
        'Non-profit organizations do important work, and they also face some of the more complex ' +
        'federal and state labor regulations around managing their paid employees and volunteers. We support ' +
        'businesses of every size and kind with their compliance needs, and help them avoid litigation with ' +
        'our safe termination plans.',
    },
    frame_body: {
      header: 'Common Compliance Risks For Non-Profit Business Owners',
      subheader: [
        'Lack of sufficient documentation of warnings needed to terminate unsatisfactory employees',
        'Appropriate safety and wage information not posted and made available to employees',
        'Team roles not correctly categorized as exempt/non-exempt',
        'Employees failing to track hours worked',
        'Non-compliance with industry insurance laws, specifically ACA',
      ],
    },
    business_lists: ['Religious', 'Educational', 'Charitable', 'Agricultural'],
  },

  automotive: {
    frame_head: {
      header: '',
      subheader: '',
    },
    frame_body: {
      header: '',
      subheader: [],
    },
    business_lists: [],
  },

  catering: {
    frame_head: {
      header: '',
      subheader: '',
    },
    frame_body: {
      header: '',
      subheader: [],
    },
    business_lists: [],
  },

  professional: {
    frame_head: {
      header: '',
      subheader: '',
    },
    frame_body: {
      header: '',
      subheader: [],
    },
    business_lists: [],
  },

  finance: {
    frame_head: {
      header: '',
      subheader: '',
    },
    frame_body: {
      header: '',
      subheader: [],
    },
    business_lists: [],
  },
};

export const industryBoxes = [
  {
    image: '/assets/information/industry/food.svg',
    icon: ['fal', 'cheeseburger'],
    heading: 'Food & Beverage',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/industries/food',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/industry/retail.svg',
    icon: ['fal', 'store'],
    heading: 'Retail',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/industries/retail',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  /* {
     image: "assets/information/industry/professional.svg",
     icon: false,
     heading: "Professional",
     subheading: "Donec quam felis, ultricies nec, pellentesque eu, pretium quis",
     slug: "/industry/professional",
     top_border: false,
     mid_border: false,
     bot_border: false,
     button: false,
     empty: false
     }, */
  /* {
     image: "assets/information/industry/finance.svg",
     icon: false,
     heading: "Finance",
     subheading: "Donec quam felis, ultricies nec, pellentesque eu, pretium quis",
     slug: "/industry/finance",
     top_border: true,
     mid_border: true,
     bot_border: true,
     button: false,
     empty: false
     }, */
  {
    image: '/assets/information/industry/entertainment.svg',
    icon: ['fal', 'tv'],
    heading: 'Entertainment',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/industries/entertainment',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/industry/healthcare.svg',
    icon: ['fal', 'heartbeat'],
    heading: 'Healthcare / Medical',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/industries/healthcare',
    top_border: false,
    mid_border: false,
    bot_border: false,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/industry/technology.svg',
    icon: ['fal', 'memory'],
    heading: 'Technology',
    subheading: 'Software, Internet, Mobile, Telecommunication',
    slug: '/industries/technology',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/industry/education.svg',
    icon: ['fal', 'graduation-cap'],
    heading: 'Education',
    subheading: 'Books, Textbooks, More Books',
    slug: '/industries/education',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  /* {
     image: "assets/information/industry/catering.svg",
     icon: false,
     heading: "Catering / Events",
     subheading: "Software, Internet, Mobile, Telecommunications",
     slug: "/industry/catering",
     top_border: false,
     mid_border: false,
     bot_border: false,
     button: false,
     empty: false
     }, */
  {
    image: '/assets/information/industry/hospitality.svg',
    icon: ['fal', 'hotel'],
    heading: 'Hotels',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/industries/hospitality',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/industry/security.svg',
    icon: ['fal', 'shield-alt'],
    heading: 'Security',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/industries/security',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/industry/caregivers.svg',
    icon: ['fal', 'hospital-user'],
    heading: 'Caregivers',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/industries/caregiver',
    top_border: false,
    mid_border: false,
    bot_border: false,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/industry/insurance.svg',
    icon: ['fal', 'user-shield'],
    heading: 'Insurance',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/industries/insurance',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  /* {
     image: "assets/information/industry/automotive.svg",
     icon: false,
     heading: "Automotive",
     subheading: "Donec quam felis, ultricies nec, pellentesque eu, pretium quis",
     slug: "/industry/automotive",
     top_border: true,
     mid_border: true,
     bot_border: true,
     button: false,
     empty: false
     }, */
  {
    image: '/assets/information/industry/manufacturing.svg',
    icon: ['fal', 'industry'],
    heading: 'Manufacturing',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/industries/manufacturing',
    top_border: false,
    mid_border: false,
    bot_border: false,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/industry/customer-support.svg',
    icon: ['fal', 'headset'],
    heading: 'Customer Support',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/industries/customersupport',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/industry/energy.svg',
    icon: ['fal', 'lightbulb-on'],
    heading: 'Energy',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/industries/energy',
    top_border: true,
    mid_border: true,
    bot_border: true,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/industry/construction.svg',
    icon: ['fal', 'hard-hat'],
    heading: 'Construction',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/industries/construction',
    top_border: false,
    mid_border: false,
    bot_border: false,
    button: false,
    empty: false,
  },
  {
    image: '/assets/information/industry/non-profit.svg',
    icon: ['fal', 'globe-americas'],
    heading: 'Non-Profit',
    subheading:
      'Donec quam felis, ultricies nec, pellentesque eu, pretium quis',
    slug: '/industries/nonprofit',
    top_border: true,
    mid_border: true,
    bot_border: false,
    button: false,
    empty: false,
  },

  /* {
     image: "/transparent.gif",
     icon: false,
     heading: "aa",
     subheading: "Donec quam felis, ultricies nec, pellentesque eu, pretium quis",
     slug: "",
     top_border: true,
     mid_border: true,
     bot_border: false,
     button: false,
     empty: true
     },
     {
     image: "/transparent.gif",
     icon: false,
     heading: "Non-Profit",
     subheading: "Donec quam felis, ultricies nec, pellentesque eu, pretium quis",
     slug: "",
     top_border: true,
     mid_border: true,
     bot_border: false,
     button: false,
     empty: true
     } */
];

export const benefits = [
  {
    title: 'Dedicated HR Manager',
    body: 'Not a call center or a hotline, your HR manager is dedicated to you.',
    icon: '/assets/information/benefits/headphones-customer-support-human.svg',
  },
  {
    title: 'In-Depth HR Audit',
    body: 'We audit your current HR business practices and help uncover hidden risks to your business.',
    icon: '/assets/information/benefits/todos-line.svg',
  },
  {
    title: 'Written Policies',
    body: 'We’ll work with you to craft your internal HR policies that fit the way you run your business.',
    icon: '/assets/information/benefits/policies-line.svg',
  },
  {
    title: 'A Powerful Platform',
    body: 'Store documents and company date in a platform designed to help you avoid mistakes',
    icon: '/assets/information/benefits/desktop-monitor-smiley-1.svg',
  },
  {
    title: 'Unbiased Guidance & Coaching',
    body: 'Not a call center or a hotline, your HR manager is dedicated to you.',
    icon: '/assets/information/benefits/strategy.svg',
  },
  {
    title: 'Unlimited HR Support',
    body: 'Available to help by phone, email, or chat. Consider us an extension of your team.',
    icon: '/assets/information/benefits/time-clock-circle-1.svg',
  },
];
